// TODO: replace 'any' with correct types when more time
/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components'
import ReactSlider from 'react-slider'

export const StyledSlider = styled(ReactSlider)`
    width: 190px;
`
export const StyledThumb = styled.div`
    height: 20px;
    width: 20px;
    background-color: ${({ theme }) => theme.colors.secondary_500};
    border-radius: 50%;
    cursor: grab;
    margin-top: -8px;
`
export const StyledTrack = styled.div`
    top: 0;
    bottom: 0;
    background: ${({ index, theme }: any) =>
        index === 1 ? theme.colors.grayscale_400 : theme.colors.secondary_500};
    border-radius: 3px;
    height: 4px;
`
